import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/auth';

interface LoginLocationState {
  from?: {
    pathname?: string;
    search?: string;
  };
}

export function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  const state = location.state as LoginLocationState | null;
  const returnTo = state?.from
    ? `${state.from.pathname ?? ''}${state.from.search ?? ''}` || '/'
    : '/';

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      login(returnTo);
    }
  }, [isAuthenticated, isLoading, login, returnTo]);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-sm text-muted-foreground">Redirecting to login...</div>
    </div>
  );
}
